// App.js
import useAppStore from "@/store/use-app-store";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getUA } from "data/functions";
import React from "react";

export function DeviceUpdater() {
  const theme = useTheme();
  const isMidUp = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });

  const isMobile = !isMidUp;
  const isPad = !isLgUp && isMidUp;
  const isDesktop = isLgUp;

  React.useEffect(() => {
    useAppStore.setState(() => ({
      isDesktop,
      isMobile,
      isPad,
    }));
  }, [isMobile, isPad, isDesktop]);

  React.useEffect(() => {
    useAppStore.setState(() => ({
      platform: getUA(),
    }));
  }, []);
}
